export default {"src":"/_next/static/media/outdoor-kitchen.f58bcc41.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};